import axios from "axios";
import authManager from "./authManager";

const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});
instance.interceptors.request.use((config) => {
  config.params = config.params || {};
  return config;
});

export { instance };

let logoutFn = null;

export const setLogoutFunction = (fn) => {
  logoutFn = fn;
};

export const setupInterceptors = (instance) => {
  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error.response?.status;
      const url = error.config?.url || "";

      const bypassUrls = ["/api/user/v1/profile"];
      const shouldBypass = bypassUrls.some((u) => url.includes(u));

      if ((status === 401 || status === 403) && !shouldBypass && logoutFn) {
        logoutFn();
      }

      return Promise.reject(error);
    }
  );
};
// instance.interceptors.request.use(async (config) => {
//   config.params = config.params || {};
//   const method = config.method?.toLowerCase();
//   const needsCsrf = ["post", "put", "patch", "delete"].includes(method || "");
//   if (needsCsrf) {
//     const res = await instance.get("/api/csrf-token");
//     config.headers["X-CSRF-Token"] = res.data.csrfToken;
//   }
//   return config;
// });

const apiRequest = {
  getSetting: ({ v = "v1" } = {}) => instance.get(`getHomeData`),

  getHomeData: ({ v = "v1" } = {}) =>
    instance.get(`/api/${v}/getHomeData`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  login: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/login`, body),

  sendOtp: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/sendOtp`, body),

  register: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/register`, body),

  getProfile: ({ v = "v1" } = {}) =>
    instance.get(`/api/user/${v}/profile`, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),
  updateProfile: ({ v = "v1", body = {} } = {}) =>
    instance.post(`/api/user/${v}/updateProfile`, body, {
      headers: {
        Authorization: `Bearer ${authManager.getAccessToken()}`,
      },
    }),

  contactSubmit: ({ v = "v1", body = {} } = {}) =>
    instance.post(`contact`, body),
};

export default apiRequest;
